module.exports = __webpack_public_path__ + "static/angie_portrait-33ac29a39dda5f619a85e457c3871654.jpg";